import _values from 'lodash/values';

const sharingFields = {
  LINK:    'link',
  TITLE:   'title',
  BYLINE:  'byline',
  MESSAGE: 'message',
  PICTURE: 'imageAssetRef',
};

sharingFields.ALL = _values(sharingFields);
export default sharingFields;
